import { useTaskTags } from "../api/queries/useTaskTags"
import { MultiSelect } from "primereact/multiselect"

export default function TaskTagMultiFilter(props) {
  const { data: taskTags = [] } = useTaskTags()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={taskTags}
      optionLabel={"name"}
      optionValue={"uuid"}
      placeholder={"Typ"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
